import { render, staticRenderFns } from "./my-reward.vue?vue&type=template&id=fc656c0c"
import script from "./my-reward.vue?vue&type=script&lang=js"
export * from "./my-reward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports